export const TEMPORAL_SCOPE = ({
  INTERVAL: 'INTERVAL',
  INSTANT: 'INSTANT'
} as const);
export const CARDINALITY = ({
  ONE_TO_ONE: 'ONE_TO_ONE',
  ONE_TO_MANY: 'ONE_TO_MANY',
  MANY_TO_ONE: 'MANY_TO_ONE',
  MANY_TO_MANY: 'MANY_TO_MANY'
} as const);
export const DIRECTIONALITY = ({
  DIRECTED: 'DIRECTED',
  // source -> target
  UNDIRECTED: 'UNDIRECTED'
} as const);
export const FRAME_FIELD = ({
  START: 'startFrame',
  END: 'endFrame'
} as const);
export const RELATIONSHIP_CONSTANTS = ({
  SECTION_TITLE: 'Relationship',
  CREATE_BUTTON: 'Create',
  NO_RELATIONSHIPS: 'No relationships',
  TARGET_PREFIX: 'Target',
  EDIT_TOOLTIP: 'Edit Relationship',
  DELETE_TOOLTIP: 'Delete Relationship',
  FRAMES: 'Frames:'
} as const);
export const RELATIONSHIP_CREATOR_CONSTANTS = ({
  SUBTITLE: 'Link 2 or more objects',
  SOURCE_LABEL: 'Source object',
  RELATIONSHIP_TYPE_LABEL: 'Relationship type',
  SAME_INTERVAL_LABEL: 'Same interval for all target objects',
  TARGET_LABEL: 'Target object',
  START_FRAME_LABEL: 'Start frame',
  END_FRAME_LABEL: 'End frame',
  ADD_TARGET_BUTTON: 'Add target object',
  CANCEL_BUTTON: 'Cancel',
  CREATE_BUTTON: 'Create relationship',
  SAVE_BUTTON: 'Save',
  SELECT_TARGET_PLACEHOLDER: 'Select a target object',
  SELECT_TYPE_PLACEHOLDER: 'Select relationship type',
  VALIDATION_SELECT_TYPE: 'Please select a relationship type',
  VALIDATION_SELECT_TARGET: 'Please select at least one target',
  VALIDATION_FRAME_RANGE: 'Frame range is required',
  VALIDATION_END_BEFORE_START: 'End frame must be greater than start frame',
  VALIDATION_START_FRAME_OUT_OF_RANGE: 'Start frame is outside the object instance',
  VALIDATION_END_FRAME_OUT_OF_RANGE: 'End frame is outside the object instance',
  VALIDATION_NO_OVERLAP: 'Source and target annotations do not overlap',
  TITLE: 'Relationship'
} as const);